module.exports = __webpack_public_path__ + "img/computadores.7018cb0d.png";